import { httpService } from 'src/services';
import { ApiUrl } from 'src/constants';
import { HydraResponse, Response } from 'src/api/hydraResponse';
import {
  IMarketplace,
} from 'src/components/profileComponents/Marketplace/types';
import {
  IMarketplaceComplexTileConfig,
  IMarketplaceLanguageObjects, IMarketplaceLanguageObjectsData,
} from 'src/typings/marketplace';
import { ITranslationData } from 'src/store/requests/translations/reducer';

export function getMarketplaces(token: string = ''): Promise<HydraResponse<IMarketplace[]>> {
  return httpService.get(`${ApiUrl.getApiUrl().getMarketplaces}`, {}, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/ld+json',
  });
}

export function getMarketplaceById(token: string = '', id: number): Promise<Response<IMarketplace>> {
  return httpService.get(`${ApiUrl.getApiUrl().getPublicMarketplaces}/${id}`, {}, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/ld+json',
  });
}

export function postMarketplace(token: string = '', data: any) {
  return httpService.post(`${ApiUrl.getApiUrl().getMarketplaces}`, data, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/ld+json',
  });
}

export function putMarketplace(token: string = '', id: string, data: any) {
  return httpService.put(`${ApiUrl.getApiUrl().getMarketplaces}/${id}`, data, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/ld+json',
  });
}

export function putMarketplaceModule(token: string = '', id: string, data: any) {
  return httpService.put(`${ApiUrl.getApiUrl().getMarketplaceModule}/${id}`, data, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/ld+json',
  });
}

export function getMarketplaceLanguageObjects(token: string = '', data: IMarketplaceLanguageObjectsData): Promise<{data: IMarketplaceLanguageObjects}> {
  return httpService.post(`${ApiUrl.getApiUrl().getMarketplacesLanguageObjects}`, data, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/ld+json',
  });
}

export function getMarketplaceTiles(token: string = '', params: string): Promise<HydraResponse<IMarketplaceComplexTileConfig[]>> {
  return httpService.get(`${ApiUrl.getApiUrl().getMarketplaceTiles}${params}`, {}, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/ld+json',
  });
}

export function putMarketplaceTiles(token: string = '', params: string, data: IMarketplaceComplexTileConfig): Promise<HydraResponse<IMarketplaceComplexTileConfig[]>> {
  return httpService.put(`${ApiUrl.getApiUrl().getMarketplaceTiles}${params}`, data, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/ld+json',
  });
}

export function getMarketplaceTranslationRequestData(complexId: string, lang: string): Promise<Response<ITranslationData>> {
  return httpService.get(`${ApiUrl.getApiUrl().getTranslations}?id=${complexId}&lang=${lang}`);
}
